export const awsConfig = {
  aws_project_region: 'us-east-2',
  aws_appsync_region: 'us-east-2',
  aws_appsync_graphqlEndpoint:
    'https://lnbcj662qfhi3acavq2oaspkdy.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_apiKey: 'da2-lv5vcnjp4rbyfgrcvzbfpdhyv4',
  // AUTH
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_CfEcNnBni',
  aws_user_pools_web_client_id: '7c879mbid2cg95umlhcnlo83qi',

  oauth: {
    domain: 'conneqt.auth.us-east-2.amazoncognito.com',
    scope: ['openid', 'email', 'phone', 'profile'],
    redirectSignIn: 'https://conneqt.hitiq.com/',
    redirectSignOut: 'https://conneqt.hitiq.com/',
    responseType: 'code',
  },
  aws_cognito_login_mechanisms: ['PREFERRED_USERNAME'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_logger_region: 'us-east-2',
  aws_appsync_geoIpEndpoint:
    'https://zwkywb3zq5.execute-api.us-east-2.amazonaws.com/Prod/geoip-lookup',
};
